import { useQuery } from '@tanstack/react-query';

import { hasPermission } from '@enterprise/api';

import { datastreamQueryKeys } from '@/common/query-keys';
import { useApplicationStore } from '@hooks/application/application-store.hook';

export const useHasPermission = (permissions: string[] | string) => {
  const enterpriseApi = useApplicationStore(({ enterpriseApi }) => {
    return enterpriseApi;
  });

  const check = Array.isArray(permissions) ? permissions : [permissions];

  return useQuery({
    queryFn: () => {
      return hasPermission(enterpriseApi, check);
    },
    queryKey: datastreamQueryKeys.auth.permission(check),
    select: (result) => {
      if (result.failure) {
        return {};
      }

      return (result.data ?? []).reduce<Record<string, boolean>>((accumulator, { hasPermission, name }) => {
        accumulator[name] = hasPermission;

        return accumulator;
      }, {});
    },
  });
};
